import { handleEvoWrapperMessages } from '@oss/utils';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { initializeDataDog } from '@ezugi/analytics/initializeDataDog';

import '@ezugi/polyfills.js';

import 'modern-normalize';

import App from './App';
import { RouteContextProvider } from './contexts/RouteContext';
import configureAppStore from './store';
import { analytics } from './store/analytics';

import './styles.css';

/* eslint-disable no-undef */
/**
 * Add global variables for app & tag version
 * Replaced by Vite at build time
 */
window.__VERSION = __VERSION;
window.__TAG_VERSION = __TAG_VERSION;
/* eslint-enable no-undef */

initializeDataDog();

const store = configureAppStore();

const root = createRoot(document.getElementById('root'));

window.addEventListener('message', (event) => handleEvoWrapperMessages(event, store));
window.addEventListener('pageshow', (event) => {
  const shouldReload = event.persisted
    || performance.getEntriesByType('navigation').at(-1)?.type === 'back_forward';

  if (!shouldReload) return;

  window.location.reload();
});

function render() {
  store.dispatch(analytics.requestConfig());

  root.render(
    <Provider store={store}>
      <React.StrictMode>
        <RouteContextProvider>
          {({ basename }) => (
            <BrowserRouter basename={basename}>
              <App />
            </BrowserRouter>
          )}
        </RouteContextProvider>
      </React.StrictMode>
    </Provider>
  );
}

const urlParams = new URLSearchParams(window.location.search);

if (urlParams.has('operatorId') && urlParams.has('token')) {
  import('./handleAuthentication')
    .then(({ auth }) => auth(urlParams))
    .finally(render);
} else {
  render();
}
